// extracted by mini-css-extract-plugin
export default {"WidgetBackground":"ToolbarComponents_WidgetBackground__Lw5BY"};